import Controller from "./quickview.controller";
import template from "./quickview.html";

const quickview = {
  template,
  controller: Controller,
  bindings: {
    title: "<",
    items: "<",
  },
};

export default quickview;



// WEBPACK FOOTER //
// ./src/components/quickview/quickview.component.js